// 指標裝置能力判斷
// 用來決定要不要加「hover 外框 + cursor: pointer」這類只對滑鼠（桌機）有意義的互動回饋。
//
// === 使用圖片 ===
// 無 — 純能力偵測，不渲染任何畫面。

let cached: boolean | null = null;

/**
 * 是否為「具備精確指標 + hover 能力」的裝置（桌機滑鼠 / trackpad）。
 *
 * 用 CSS media query `(hover: hover) and (pointer: fine)` 判斷：
 *   - 桌機滑鼠 → true（可 hover、指標精確）
 *   - 純觸控手機 / 平板 → false（無 hover、指標粗略）
 *
 * 非瀏覽器環境（測試）回 false。結果快取（裝置能力一個 session 內不會變）。
 */
export function supportsHover(): boolean {
  if (cached !== null) return cached;
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    cached = false;
    return cached;
  }
  cached = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  return cached;
}
